export function formatUnit(value, unit) {
  if (value !== null && value !== undefined && !!unit?.length) {
    const nf = new Intl.NumberFormat("it-IT", {
      style: "unit",
      unit: unit,
    }).format(value);
    return nf;
  }
}
